import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Plus, Search, Archive, FileSpreadsheet, ChevronDown, ChevronLeft, ChevronRight, Landmark, Shield, CheckCircle, Upload, Info, FileText, ChevronUp, Filter, Save, X, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../services/api';
import SearchableSelect from '../components/SearchableSelect';
import XLSX from 'xlsx-js-style';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import ImportModal from '../components/ImportModal';
import GroupPanel from '../components/GroupPanel';
import ColumnHeaderFilter from '../components/ColumnHeaderFilter';
import IconButton from '../components/IconButton';
import { groupData, aggregate, formatCurrency } from '../utils/grouping';

const MesAnoFilterInput = ({ initialValue, onApply }) => {
    const [value, setValue] = useState(initialValue || '');

    const handleChange = (e) => {
        let v = e.target.value.replace(/\D/g, '');
        if (v.length > 6) v = v.slice(0, 6);
        if (v.length > 2) v = v.slice(0, 2) + '/' + v.slice(2);
        setValue(v);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onApply(value);
        }
    };

    return (
        <div className="flex gap-2 items-center">
            <div className="w-36">
                <input
                    type="text"
                    maxLength={7}
                    placeholder="MM/AAAA"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                />
            </div>
            <IconButton
                icon={Search}
                onClick={() => onApply(value)}
                variant="primary"
                title="Aplicar filtro"
            />
        </div>
    );
};

const SearchInput = ({ initialValue, onSearch }) => {
  const [value, setValue] = useState(initialValue || '');

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSearch(value);
    }
  };

  return (
    <div className="relative mb-4 mt-4">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
      <input
        type="text"
        placeholder="Buscar... (Ex: N:Maria C:123)"
        className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
        value={value}
        onChange={(e) => setValue(e.target.value.toUpperCase())}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

const Consolidacao = () => {
  
  const [items, setItems] = useState([]);
  const [showFilters, setShowFilters] = useState(true);
  const [clientes, setClientes] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [faixas, setFaixas] = useState([]);
  const [regras, setRegras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cdlAceFilter, setCdlAceFilter] = useState('TODOS');
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingItem, setDeletingItem] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showExportDropdown, setShowExportDropdown] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [obsModalItem, setObsModalItem] = useState(null);
  const [breakFields, setBreakFields] = useState([]);
  const [itemsPerPage, setItemsPerPage] = useState(2500);
  const [currentPage, setCurrentPage] = useState(1);
  const [columnFilters, setColumnFilters] = useState({});
  const [mesAnoFilter, setMesAnoFilter] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const formatDateDisplay = (isoString) => {
    if (!isoString) return '-';
    if (isoString.includes('T')) {
      return new Date(isoString).toLocaleDateString('pt-BR');
    }
    const [yyyy, mm, dd] = String(isoString).split('-');
    return `${dd}/${mm}/${yyyy}`;
  };

  const calcAge = (isoString) => {
    if (!isoString) return '-';
    let d;
    if (String(isoString).includes('T')) {
      d = new Date(isoString);
    } else {
      const parts = String(isoString).split('-');
      if (parts.length !== 3) return '-';
      const yyyy = parseInt(parts[0], 10);
      const mm = parseInt(parts[1], 10) - 1;
      const dd = parseInt(parts[2], 10);
      d = new Date(yyyy, mm, dd);
    }
    if (Number.isNaN(d.getTime())) return '-';
    const today = new Date();
    let age = today.getFullYear() - d.getFullYear();
    const m = today.getMonth() - d.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < d.getDate())) age--;
    return age >= 0 ? String(age) : '-';
  };

  const importFields = [
    { key: 'nome_cons', label: 'Nome Consolidação', required: true },
    { key: 'nome_mov', label: 'Nome Movimentação', required: false },
    { key: 'cpf_mov', label: 'CPF', required: false },
    { key: 'dt_nasc_mov', label: 'Data Nascimento', required: false },
    { key: 'matricula_mov', label: 'Matrícula', required: false },
    { key: 'empresa_mov', label: 'Empresa', required: false },
    { key: 'cd_empresa_mov', label: 'Cód. Empresa', required: false },
    { key: 'id_grupo_mov', label: 'ID Grupo', required: false },
    { key: 'id_faixa_mov', label: 'ID Faixa', required: false },
    { key: 'id_sub_mov', label: 'ID Sub', required: false },
    { key: 'dt_cad', label: 'Data Cadastro', required: false },
    { key: 'mesano', label: 'Mês/Ano', required: false },
    { key: 'obs', label: 'Observação', required: false },
    { key: 'unit_mov', label: 'Valor Unit.', required: false },
    { key: 'valor_mov', label: 'Valor Total', required: false },
  ];

  const handleImportData = async (data) => {
    setShowImportModal(false);
    const toastId = toast.loading('Importando registros...');
    let successCount = 0;
    let errorCount = 0;

    const parseExcelDate = (val) => {
        if (!val) return null;
        if (typeof val === 'number') {
            const date = XLSX.SSF.parse_date_code(val);
            return `${date.y}-${String(date.m).padStart(2,'0')}-${String(date.d).padStart(2,'0')}`;
        }
        if (typeof val === 'string') {
             if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) {
                 const [d, m, y] = val.split('/');
                 return `${y}-${m}-${d}`;
             }
             if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return val;
        }
        return null;
    };

    try {
        // Use batching if needed, but for now sequential
        for (const row of data) {
            let idGrupo = row.id_grupo_mov;
            if (idGrupo && isNaN(idGrupo)) {
                const g = grupos.find(x => x.desc_grupo && String(x.desc_grupo).toLowerCase().trim() === String(idGrupo).toLowerCase().trim());
                if (g) idGrupo = g.id_grupo;
                else idGrupo = null; // Could not resolve string to ID
            }

            let idFaixa = row.id_faixa_mov;
            if (idFaixa && isNaN(idFaixa)) {
                const f = faixas.find(x => x.desc_faixa && String(x.desc_faixa).toLowerCase().trim() === String(idFaixa).toLowerCase().trim());
                if (f) idFaixa = f.id;
                else idFaixa = null;
            }

            const payload = {
                nome_cons: row.nome_cons,
                nome_mov: row.nome_mov,
                cpf_mov: row.cpf_mov,
                dt_nasc_mov: parseExcelDate(row.dt_nasc_mov),
                matricula_mov: row.matricula_mov,
                empresa_mov: row.empresa_mov,
                cd_empresa_mov: row.cd_empresa_mov,
                id_grupo_mov: idGrupo, 
                id_faixa_mov: idFaixa, 
                id_sub_mov: row.id_sub_mov,
                dt_cad: parseExcelDate(row.dt_cad),
                mesano: row.mesano,
                obs: row.obs,
                unit_mov: row.unit_mov,
                valor_mov: row.valor_mov
            };

            // Basic cleanup of empty values
            Object.keys(payload).forEach(key => {
                if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
                    delete payload[key];
                }
            });

            try {
                await api.post('/consolidacao', payload);
                successCount++;
            } catch (err) {
                console.error('Erro importando linha', row, err);
                errorCount++;
            }
        }
        toast.dismiss(toastId);
        if (errorCount === 0) {
            toast.success(`${successCount} registros importados com sucesso!`);
        } else {
            toast.success(`${successCount} importados. ${errorCount} falhas.`);
        }
        loadItems();
    } catch (err) {
        console.error(err);
        toast.dismiss(toastId);
        toast.error('Erro geral na importação');
    }
  };

  const [formData, setFormData] = useState({
    id_mov: '',
    nome_cons: '',
    nome_mov: '',
    dt_nasc_mov: '',
    cpf_mov: '',
    id_faixa_mov: '',
    id_sub_mov: '',
    id_grupo_mov: '',
    cd_empresa_mov: '',
    empresa_mov: '',
    matricula_mov: '',
    dt_cad: '',
    mesano: '',
    obs: ''
  });

  const dtNascRef = useRef(null);

  useEffect(() => {
    loadItems();
    loadClientes();
    loadGrupos();
    loadRegras();
    loadFaixas();
  }, []);

  useEffect(() => { document.title = 'Consolidação - EstOX'; }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [mesAnoFilter, cdlAceFilter, columnFilters, breakFields]);

  const loadItems = async () => {
    try {
      const response = await api.get('/consolidacao');
      setItems(response.data.data || []);
    } catch (error) {
      console.error('Erro ao carregar consolidações:', error);
      toast.error('Erro ao carregar consolidações');
    } finally {
      setLoading(false);
    }
  };

  const loadClientes = async () => {
    try {
      const response = await api.get('/cliente');
      setClientes(response.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const loadGrupos = async () => {
    try {
      const response = await api.get('/gruposegur');
      setGrupos(response.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const loadFaixas = async () => {
    try {
      const response = await api.get('/faixas');
      setFaixas(response.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const loadRegras = async () => {
    try {
      const response = await api.get('/regras');
      setRegras(response.data.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const getGrupoDesc = (item) => {
    if (!item) return '-';
    if (item.desc_grupo_mov) return item.desc_grupo_mov;
    const g = grupos.find(g => g && String(g.id_grupo) === String(item.id_grupo_mov));
    return g?.desc_grupo || '-';
  };

  const getEmpresaNome = (item) => {
    if (!item) return '-';
    const cli = clientes.find(c => c && String(c.cd_supera_cli) === String(item.cd_empresa_mov))
      || clientes.find(c => c && String(c.nome_cli) === String(item.empresa_mov));
    return cli?.nome_cli || item.empresa_mov || '-';
  };

  const getCdlAce = (item) => {
    if (!item) return '-';
    if (item.id_cdl_ace) return item.id_cdl_ace;
    const cli = clientes.find(c => c && String(c.cd_supera_cli) === String(item.cd_empresa_mov))
      || clientes.find(c => c && String(c.nome_cli) === String(item.empresa_mov));
    return cli?.id_cdl_ace || '-';
  };

  const getFaixaDesc = (item) => {
    const f = faixas.find(x => x && String(x.id) === String(item.id_faixa_mov));
    return f?.desc_faixa || (item.id_faixa_mov ?? '-');
  };

  const formatBRL = (value) => {
    if (value === null || value === undefined || String(value).trim() === '') return '-';
    if (typeof value === 'number') {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    }
    try {
      const s = String(value).trim();
      const clean = s.replace(/[^0-9,.-]/g, '');
      const parsed = clean.includes(',') ? parseFloat(clean.replace(/\./g, '').replace(',', '.')) : parseFloat(clean);
      if (Number.isNaN(parsed)) return s;
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parsed);
    } catch (_) {
      return String(value);
    }
  };

  const getFaixaValor = (item) => {
    const f = faixas.find(x => String(x.id) === String(item.id_faixa_mov));
    return formatBRL(f?.valor_faixa);
  };

  const getVlUnit = (item) => {
    // Se ja estiver validado (salvo no banco), retorna o valor do banco
    if (item.unit_mov) return formatBRL(item.unit_mov.replace(',', '.'));

    const ageStr = calcAge(item.dt_nasc_mov);
    if (ageStr === '-') return '-';
    const age = parseInt(ageStr, 10);
    if (Number.isNaN(age)) return '-';

    const rule = regras.find(r => {
      const start = r.idade_inicial_regra !== null ? r.idade_inicial_regra : -Infinity;
      const end = r.idade_final_regra !== null ? r.idade_final_regra : Infinity;
      return age >= start && age <= end;
    });

    if (!rule) return '-';

    let taxaVal = 0;
    if (rule.taxa) {
      const t = String(rule.taxa).replace(',', '.');
      taxaVal = parseFloat(t);
    }
    if (Number.isNaN(taxaVal)) return '-';

    const f = faixas.find(x => String(x.id) === String(item.id_faixa_mov));
    if (!f || f.valor_faixa === null || f.valor_faixa === undefined) return '-';

    let valorVal = 0;
    if (typeof f.valor_faixa === 'number') {
      valorVal = f.valor_faixa;
    } else {
      const s = String(f.valor_faixa).trim();
      const clean = s.replace(/[^0-9,.-]/g, '');
      valorVal = clean.includes(',') ? parseFloat(clean.replace(/\./g, '').replace(',', '.')) : parseFloat(clean);
    }

    if (Number.isNaN(valorVal)) return '-';

    const raw = (taxaVal * valorVal) / 100;
    const rounded = Math.ceil(raw * 100) / 100;

    return formatBRL(rounded);
  };

  const getBreakValueFor = (item, field) => {
    switch (field) {
      case 'empresa': return getEmpresaNome(item);
      case 'grupo': return getGrupoDesc(item);
      case 'faixa': return getFaixaDesc(item);
      case 'mesano': return item.mesano || '-';
      case 'consolidacao': return item.nome_cons || '-';
      case 'data': return formatDateDisplay(item.dt_cad) || '-';
      case 'sub': return item.id_sub_mov ?? '-';
      case 'id': return item.id_mov ?? '-';
      case 'cdl_ace': return getCdlAce(item);
      case 'cpf': return item.cpf_mov || '-';
      case 'nome': return item.nome_mov || '-';
      case 'nasc': return formatDateDisplay(item.dt_nasc_mov) || '-';
      case 'idade': return calcAge(item.dt_nasc_mov);
      case 'valor': return getFaixaValor(item);
      case 'vl_unit': return getVlUnit(item);
      case 'matricula': return item.matricula_mov || '-';
      default: return '';
    }
  };

  const getUniqueValues = (key) => {
    const values = new Set();
    items.forEach(item => {
       const val = getBreakValueFor(item, key);
       values.add(String(val));
    });
    return Array.from(values).sort();
  };

  const handleFilterChange = (key, selectedVals) => {
    setColumnFilters(prev => ({
        ...prev,
        [key]: selectedVals
    }));
  };

  const filtered = useMemo(() => {
    const normalize = (text) => String(text || '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

    const term = searchTerm.trim();
    let nameFilter = '';
    let cpfFilter = '';
    let empFilter = '';
    let generalFilter = term;

    if (term) {
        const nMatch = generalFilter.match(/N:\s*([^\s]+)/i);
        if (nMatch) {
            nameFilter = normalize(nMatch[1]);
            generalFilter = generalFilter.replace(nMatch[0], '');
        }
        
        const cMatch = generalFilter.match(/C:\s*([^\s]+)/i);
        if (cMatch) {
            cpfFilter = normalize(cMatch[1]);
            generalFilter = generalFilter.replace(cMatch[0], '');
        }
        
        const eMatch = generalFilter.match(/E:\s*([^\s]+)/i);
        if (eMatch) {
            empFilter = normalize(eMatch[1]);
            generalFilter = generalFilter.replace(eMatch[0], '');
        }
        generalFilter = normalize(generalFilter.trim());
    }

    return items.filter(m => {
      const matchesSearch = (
        String(m.mesano ?? '').toLowerCase().includes(String(mesAnoFilter).toLowerCase())
      );
  
      let matchesCdlAce = true;
      if (cdlAceFilter !== 'TODOS') {
        const val = getCdlAce(m);
        if (String(val) !== cdlAceFilter) {
          matchesCdlAce = false;
        }
      }
  
      let matchesColumnFilters = true;
      for (const [key, selectedVals] of Object.entries(columnFilters)) {
          if (!selectedVals) continue; 
          const val = String(getBreakValueFor(m, key));
          if (!selectedVals.includes(val)) {
              matchesColumnFilters = false;
              break;
          }
      }

      if (!matchesSearch || !matchesCdlAce || !matchesColumnFilters) return false;

      if (!term) return true;

      if (nameFilter && !normalize(m.nome_mov).includes(nameFilter)) return false;
      if (cpfFilter && !normalize(m.cpf_mov).includes(cpfFilter)) return false;
      if (empFilter) {
            const empName = normalize(getEmpresaNome(m));
            if (!empName.startsWith(empFilter)) return false;
      }

      if (generalFilter) {
            const matchesGeneral = (
            normalize(m.nome_mov).includes(generalFilter) ||
            normalize(m.cpf_mov).includes(generalFilter) ||
            normalize(m.empresa_mov).includes(generalFilter) ||
            normalize(getEmpresaNome(m)).includes(generalFilter)
            );
            if (!matchesGeneral) return false;
      }
  
      return true;
    });
  }, [items, searchTerm, mesAnoFilter, cdlAceFilter, columnFilters, clientes]);

  const availableColumns = [
    { value: 'empresa', label: 'Empresa' },
    { value: 'grupo', label: 'Grupo' },
    { value: 'faixa', label: 'Faixa' },
    { value: 'sub', label: 'Sub' },
    { value: 'mesano', label: 'Mês/Ano' },
    { value: 'data', label: 'Data' },
    { value: 'consolidacao', label: 'Consolidação' },
    { value: 'id', label: 'ID' },
    { value: 'cdl_ace', label: 'CDL/ACE' }
  ];

  const labelForField = (field) => availableColumns.find(o => o.value === field)?.label || field;

  // Handlers para o GroupPanel
  const handleAddGroup = (field) => {
    setBreakFields((prev) => (prev.includes(field) ? prev : [...prev, field]));
  };

  const handleRemoveGroup = (field) => {
    setBreakFields((prev) => prev.filter((f) => f !== field));
  };

  const handleClearGroups = () => {
    setBreakFields([]);
  };

  const handleReorderGroup = (fromIndex, toIndex) => {
    setBreakFields((prev) => {
      const arr = [...prev];
      if (fromIndex < 0 || fromIndex >= arr.length) return arr;
      const [moved] = arr.splice(fromIndex, 1);
      const insertAt = Math.max(0, Math.min(toIndex, arr.length));
      arr.splice(insertAt, 0, moved);
      return arr;
    });
  };

  // Prepara os dados agrupados e paginação
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filtered.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  const groupedData = groupData(currentItems, breakFields, getBreakValueFor);
  const grandTotal = aggregate(currentItems, { valor_mov: 'sum', unit_mov: 'sum' });

  // Componente recursivo para renderizar linhas
  const RenderRows = ({ nodes, level = 0 }) => {
    if (!nodes || nodes.length === 0) return null;

    return nodes.map((node, idx) => {
        if (!node) return null;
        // Se for um nó de grupo
        if (node.isGroup) {
            const stats = aggregate(node.leafRows, { valor_mov: 'sum' });
            return (
                <React.Fragment key={`group-${level}-${node.groupValue}-${idx}`}>
                    <tr className="bg-gray-100 hover:bg-gray-200 transition-colors">
                        <td colSpan={15} className="py-2 px-3 border-b border-gray-200">
                            <div className="flex items-center justify-between" style={{ paddingLeft: `${level * 24}px` }}>
                                <div className="flex items-center gap-2">
                                    <span className="text-[10px] uppercase font-bold text-gray-500 bg-gray-200 px-1.5 py-0.5 rounded">
                                        {labelForField(node.groupKey)}
                                    </span>
                                    <span className="font-semibold text-gray-800 text-xs">
                                        {node.groupValue}
                                    </span>
                                    <span className="text-[10px] text-gray-500 bg-white border border-gray-300 px-2 py-0.5 rounded-full shadow-sm">
                                        {node.count} itens
                                    </span>
                                </div>
                                <div className="text-[10px] font-medium text-gray-700 mr-4">
                                    Subtotal: {formatCurrency(stats.valor_mov)}
                                </div>
                            </div>
                        </td>
                    </tr>
                    <RenderRows nodes={node.children} level={level + 1} />
                </React.Fragment>
            );
        }
        
        // Se for um item (folha)
        const item = node;
        return (
            <tr key={item.id_cons} className="hover:bg-gray-50 border-b border-gray-100 transition-colors">
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap" style={{ paddingLeft: level > 0 ? `${(level * 24) + 12}px` : undefined }}>
                    {item.id_mov ?? '-'}
                  </td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.nome_mov || '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.cpf_mov || '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{formatDateDisplay(item.dt_nasc_mov) || '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{calcAge(item.dt_nasc_mov)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getEmpresaNome(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.id_sub_mov ?? '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getFaixaDesc(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getGrupoDesc(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.id_cdl_ace || '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getFaixaValor(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getVlUnit(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.matricula_mov || '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{formatDateDisplay(item.dt_cad) || '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.mesano || '-'}</td>
            </tr>
        );
    });
  };

  const exportPDF = () => {
    if (!filtered.length) {
      toast.error('Não há dados para exportar');
      return;
    }

    const doc = new jsPDF();
    const titleSuffix = cdlAceFilter === 'TODOS' ? '' : cdlAceFilter;
    
    doc.setFontSize(16);
    doc.text(`Relatório Consolidado ${titleSuffix}`, 14, 20);
    
    doc.setFontSize(10);
    doc.text(`Gerado em: ${new Date().toLocaleDateString('pt-BR')} às ${new Date().toLocaleTimeString('pt-BR')}`, 14, 26);
    if (mesAnoFilter) {
        doc.text(`Filtro Mês/Ano: ${mesAnoFilter}`, 14, 32);
    }

    const parseCurrency = (str) => {
        if (typeof str === 'number') return str;
        if (!str) return 0;
        const clean = String(str).replace(/[^\d,.-]/g, '');
        if (!clean || clean === '-') return 0;
        
        const val = clean.includes(',') 
          ? parseFloat(clean.replace(/\./g, '').replace(',', '.')) 
          : parseFloat(clean);
          
        return Number.isNaN(val) ? 0 : val;
    };

    const grouped = {};
    
    filtered.forEach(item => {
        const emp = getEmpresaNome(item);
        const faixa = getFaixaDesc(item);
        const vlUnitStr = getVlUnit(item); 
        const vlUnit = parseCurrency(vlUnitStr);
        
        if (!grouped[emp]) grouped[emp] = {};
        if (!grouped[emp][faixa]) grouped[emp][faixa] = {};
        if (!grouped[emp][faixa][vlUnitStr]) grouped[emp][faixa][vlUnitStr] = { 
            count: 0, 
            total: 0,
            vlUnit: vlUnit
        };
        
        grouped[emp][faixa][vlUnitStr].count += 1;
        grouped[emp][faixa][vlUnitStr].total += vlUnit;
    });

    const tableRows = [];
    let grandTotal = 0;
    let grandCount = 0;
    const sortedEmpresas = Object.keys(grouped).sort();

    sortedEmpresas.forEach(emp => {
        tableRows.push([{ content: emp, colSpan: 4, styles: { fillColor: [240, 240, 240], fontStyle: 'bold' } }]);
        
        const faixas = Object.keys(grouped[emp]).sort();
        let empTotal = 0;
        let empCount = 0;
        
        faixas.forEach(faixa => {
            const units = Object.keys(grouped[emp][faixa]).sort();
            units.forEach(unitStr => {
                const info = grouped[emp][faixa][unitStr];
                tableRows.push([
                    faixa,
                    unitStr,
                    info.count,
                    info.total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                ]);
                empTotal += info.total;
                empCount += info.count;
            });
        });
        
        tableRows.push([
            { content: `Total ${emp}`, colSpan: 2, styles: { fontStyle: 'bold', halign: 'right' } },
            { content: empCount, styles: { fontStyle: 'bold' } },
            { content: empTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), styles: { fontStyle: 'bold' } }
        ]);
        
        grandTotal += empTotal;
        grandCount += empCount;
    });
    
    tableRows.push([
        { content: 'TOTAL GERAL', colSpan: 2, styles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold', halign: 'right' } },
        { content: grandCount, styles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' } },
        { content: grandTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), styles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: 'bold' } }
    ]);

    autoTable(doc, {
        startY: 40,
        head: [['Faixa', 'Valor Unit.', 'Qtd', 'Valor Total']],
        body: tableRows,
        theme: 'grid',
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [44, 62, 80] },
    });

    const filename = `Relatorio_Consolidado_${cdlAceFilter}_${new Date().toISOString().slice(0,10)}.pdf`;
    doc.save(filename);
    setShowExportDropdown(false);
  };

  const exportXLS = (tipo) => {
    try {
      const formatBR = (iso) => {
        if (!iso) return '';
        if (String(iso).includes('T')) return new Date(iso).toLocaleDateString('pt-BR');
        const [yyyy, mm, dd] = String(iso).split('-');
        if (!yyyy || !mm || !dd) return '';
        return `${dd}/${mm}/${yyyy}`;
      };

      const parseCurrency = (str) => {
        if (typeof str === 'number') return str;
        if (!str) return 0;
        const clean = String(str).replace(/[^\d,.-]/g, '');
        if (!clean || clean === '-') return 0;
        
        const val = clean.includes(',') 
          ? parseFloat(clean.replace(/\./g, '').replace(',', '.')) 
          : parseFloat(clean);
          
        return Number.isNaN(val) ? 0 : val;
      };

      let dados = [];
      if (tipo === 'Seguradora') {
        if (!filtered.length) {
            toast.error('Não há dados filtrados para exportar');
            return;
        }

        const wb = XLSX.utils.book_new();

        const monthNames = [
          'JANEIRO',
          'FEVEREIRO',
          'MARÇO',
          'ABRIL',
          'MAIO',
          'JUNHO',
          'JULHO',
          'AGOSTO',
          'SETEMBRO',
          'OUTUBRO',
          'NOVEMBRO',
          'DEZEMBRO'
        ];

        const getSheetName = (mesano) => {
          const m = String(mesano || '').trim().match(/^(\d{2})\/(\d{4})$/);
          if (!m) return 'SEGURADORA';
          const mm = parseInt(m[1], 10);
          if (Number.isNaN(mm) || mm < 1 || mm > 12) return 'SEGURADORA';
          return monthNames[mm - 1];
        };

        const cargoFromFaixa = (item) => {
          const raw = String(getFaixaDesc(item) ?? '').trim();
          if (!raw) return '';
          const up = raw.toUpperCase();
          if (!up.startsWith('FAIXA')) return up;
          const digits = up.replace(/\D/g, '');
          if (!digits) return up;
          return `FAIXA ${digits.padStart(2, '0')}`;
        };

        const getSubestipulante = (item) => {
          if (!item) return 0;
          const cli = clientes.find(c => c && String(c.cd_supera_cli) === String(item.cd_empresa_mov))
            || clientes.find(c => c && String(c.nome_cli) === String(item.empresa_mov));
          const v = cli?.cod_sub_cli ?? item?.id_sub_mov;
          if (v === undefined || v === null) return 0;
          const s = String(v).trim();
          if (!s) return 0;
          if (!/^\d+$/.test(s)) return 0;
          const n = parseInt(s, 10);
          return Number.isNaN(n) ? 0 : n;
        };

        const rows = [...filtered]
          .sort((a, b) => {
            const sa = getSubestipulante(a);
            const sb = getSubestipulante(b);
            if (sa !== sb) return sa - sb;
            return String(a?.nome_mov || '').localeCompare(String(b?.nome_mov || ''), 'pt-BR');
          })
          .map(i => ({
            nome: i?.nome_mov || '',
            nasc: formatBR(i?.dt_nasc_mov),
            cpf: i?.cpf_mov || '',
            cargo: cargoFromFaixa(i),
            sub: getSubestipulante(i),
            matricula: i?.matricula_mov || ''
          }));

        const aoa = [
          ['Nome do Segurado', 'Data de nascimento', 'CPF', 'Cargo', 'Número_Subestipulante', 'Matrícula'],
          ...rows.map(r => [r.nome, r.nasc, r.cpf, r.cargo, r.sub, r.matricula])
        ];

        const ws = XLSX.utils.aoa_to_sheet(aoa);

        const groupMap = new Map();
        for (const i of filtered) {
          const id = i?.id_grupo_mov;
          if (id === undefined || id === null || String(id).trim() === '') continue;
          const key = String(id);
          if (!groupMap.has(key)) groupMap.set(key, getGrupoDesc(i));
        }
        const groups = Array.from(groupMap.entries())
          .map(([id, name]) => ({ id, name }))
          .sort((a, b) => {
            const na = Number(a.id);
            const nb = Number(b.id);
            if (!Number.isNaN(na) && !Number.isNaN(nb) && na !== nb) return na - nb;
            return String(a.name || '').localeCompare(String(b.name || ''), 'pt-BR');
          });

        const capMap = new Map();
        for (const f of (faixas || [])) {
          const raw = f?.valor_faixa;
          if (raw === undefined || raw === null || String(raw).trim() === '') continue;
          const n = typeof raw === 'number' ? raw : parseCurrency(String(raw));
          if (Number.isNaN(n)) continue;
          capMap.set(String(n), n);
        }
        const capitals = Array.from(capMap.values()).sort((a, b) => a - b);

        ws['H1'] = { t: 's', v: 'Nº Grupo' };
        ws['I1'] = { t: 's', v: 'Nome do Grupo' };
        for (let idx = 0; idx < groups.length; idx++) {
          const r = idx + 2;
          const g = groups[idx];
          const rawId = String(g.id ?? '').trim();
          const rawDigits = rawId.replace(/\D/g, '');
          const n = Number(rawDigits || rawId);
          ws[`H${r}`] = Number.isNaN(n) ? { t: 's', v: rawId } : { t: 'n', v: n, z: '0' };
          ws[`I${r}`] = { t: 's', v: g.name || '' };
        }

        ws['L1'] = { t: 's', v: 'Capital' };
        for (let idx = 0; idx < capitals.length; idx++) {
          const r = idx + 2;
          ws[`L${r}`] = { t: 'n', v: capitals[idx], z: '"R$" #,##0.00' };
        }

        const thinBorder = {
          top: { style: 'thin', color: { rgb: '000000' } },
          bottom: { style: 'thin', color: { rgb: '000000' } },
          left: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'thin', color: { rgb: '000000' } }
        };

        const headerStyle = {
          fill: { fgColor: { rgb: 'C6E0B4' } },
          font: { bold: true, color: { rgb: '000000' } },
          alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
          border: thinBorder
        };

        const cellStyle = {
          alignment: { vertical: 'center' },
          border: thinBorder
        };

        const applyStyleRange = (cStart, cEnd, rStart, rEnd, style) => {
          for (let R = rStart; R <= rEnd; R++) {
            for (let C = cStart; C <= cEnd; C++) {
              const addr = XLSX.utils.encode_cell({ c: C, r: R });
              if (!ws[addr]) continue;
              ws[addr].s = style;
            }
          }
        };

        const mainRows = aoa.length;
        const groupRows = groups.length + 1;
        const capRows = capitals.length + 1;
        const maxRows = Math.max(mainRows, groupRows, capRows, 2);

        ws['!ref'] = XLSX.utils.encode_range({ s: { c: 0, r: 0 }, e: { c: 11, r: maxRows - 1 } });

        applyStyleRange(0, 5, 0, 0, headerStyle);
        applyStyleRange(0, 5, 1, Math.max(1, mainRows - 1), cellStyle);

        applyStyleRange(7, 8, 0, 0, headerStyle);
        applyStyleRange(7, 8, 1, Math.max(1, groupRows - 1), cellStyle);

        applyStyleRange(11, 11, 0, 0, headerStyle);
        applyStyleRange(11, 11, 1, Math.max(1, capRows - 1), cellStyle);

        for (let r = 2; r <= capRows; r++) {
          const addr = `L${r}`;
          if (ws[addr]) ws[addr].z = '"R$" #,##0.00';
        }

        for (let r = 2; r <= mainRows; r++) {
          const addr = `E${r}`;
          if (ws[addr]) ws[addr].z = '0';
        }

        ws['!cols'] = [
          { wch: 46 },
          { wch: 18 },
          { wch: 18 },
          { wch: 14 },
          { wch: 24 },
          { wch: 16 },
          { wch: 3 },
          { wch: 10 },
          { wch: 34 },
          { wch: 3 },
          { wch: 3 },
          { wch: 16 }
        ];
        ws['!rows'] = [{ hpt: 18 }];

        const formatCNPJ = (cnpj) => {
          const digits = String(cnpj ?? '').replace(/\D/g, '');
          if (digits.length !== 14) return String(cnpj ?? '');
          return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12, 14)}`;
        };

        const clientesAoa = [
          ['RAZÃO SOCIAL', 'CNPJ', 'Número_Subestipulante', 'Status'],
          ...(clientes || [])
            .filter(c => c && (c.nome_cli || c.cnpj_cli || c.cod_sub_cli !== undefined))
            .sort((a, b) => {
              const ra = String(a?.cod_sub_cli ?? '').trim();
              const rb = String(b?.cod_sub_cli ?? '').trim();
              const na = /^\d+$/.test(ra) ? parseInt(ra, 10) : Number.POSITIVE_INFINITY;
              const nb = /^\d+$/.test(rb) ? parseInt(rb, 10) : Number.POSITIVE_INFINITY;
              if (na !== nb) return na - nb;
              return String(a?.nome_cli || '').localeCompare(String(b?.nome_cli || ''), 'pt-BR');
            })
            .map(c => {
              const rawSub = c?.cod_sub_cli;
              const sub = rawSub === '' || rawSub === undefined || rawSub === null ? '' : Number(rawSub);
              const ativo = String(c?.ativo_cli ?? '') === '1' ? 'Ativa' : 'Inativa';
              return [String(c?.nome_cli || ''), formatCNPJ(c?.cnpj_cli), sub, ativo];
            })
        ];

        const wsClientes = XLSX.utils.aoa_to_sheet(clientesAoa);
        wsClientes['!cols'] = [{ wch: 60 }, { wch: 22 }, { wch: 22 }, { wch: 12 }];
        for (let r = 2; r <= clientesAoa.length; r++) {
          const addr = `C${r}`;
          if (wsClientes[addr]) wsClientes[addr].z = '0';
        }
        const clientesRange = XLSX.utils.decode_range(wsClientes['!ref'] || 'A1:D1');
        for (let C = clientesRange.s.c; C <= clientesRange.e.c; C++) {
          const addr = XLSX.utils.encode_cell({ c: C, r: 0 });
          if (wsClientes[addr]) wsClientes[addr].s = headerStyle;
        }
        for (let R = 1; R <= clientesRange.e.r; R++) {
          for (let C = clientesRange.s.c; C <= clientesRange.e.c; C++) {
            const addr = XLSX.utils.encode_cell({ c: C, r: R });
            if (wsClientes[addr]) wsClientes[addr].s = cellStyle;
          }
        }

        XLSX.utils.book_append_sheet(wb, ws, getSheetName(mesAnoFilter || filtered[0]?.mesano));
        XLSX.utils.book_append_sheet(wb, wsClientes, 'NúmeroSubestipulante');
        const dataAtual = new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');
        const nomeArquivo = `Consolidacao_${tipo}_${dataAtual}.xlsx`;
        XLSX.writeFile(wb, nomeArquivo);
        toast.success(`Arquivo ${nomeArquivo} gerado com sucesso!`);
        setShowExportDropdown(false);
        return;

      } else if (tipo === 'Supera') {
        // Logica especifica para Supera:
        // Agrupar por CNPJ + ID Supera + Valor Unitario
        // Formato: CNPJ;IDSupera;VlUnit;Qtde
        const map = new Map();
        
        // Filtra para garantir que apenas itens com ID Supera valido sejam exportados
        // Se o usuario filtrou CDL, so exporta itens CDL. Se ACE, so ACE.
        // O filtered ja contem essa logica (matchesCdlAce).
        
        for (const i of filtered) {
          const cli = clientes.find(c => String(c.cd_supera_cli) === String(i.cd_empresa_mov))
            || clientes.find(c => String(c.nome_cli) === String(i.empresa_mov));
          
          // Se nao achar cliente ou nao tiver CNPJ, deve pular? Por enquanto mantemos logica original, talvez string vazia
          const cnpj = cli?.cnpj_cli?.replace(/\D/g, '') || '';
          
          const f = faixas.find(x => String(x.id) === String(i.id_faixa_mov));
          // Importante: ID Supera vem da faixa. Se nao tiver, nao consegue gerar corretamente
          const idSupera = String(f?.id_serv_faixa || '').replace(/\D/g, '');
          
          const vlUnitStr = getVlUnit(i);
          let vlUnitRaw = '';
          if (vlUnitStr && vlUnitStr !== '-' && vlUnitStr !== 'R$ -') {
             // "R$ 8,63" -> "863" (centavos)
             // Remove tudo que nao for numero. 
             // Ex: "R$ 8,63" -> replace -> "863". 
             // CUIDADO: se for "1.234,56", replace nao digitos -> "123456". OK para centavos se formato for pt-BR.
             vlUnitRaw = vlUnitStr.replace(/[^0-9]/g, '');
          } else {
             // Se valor for zerado ou invalido, assume 0
             vlUnitRaw = '0';
          }
          
          // Chave composta para agrupar
          const key = `${cnpj}|${idSupera}|${vlUnitRaw}`;
          if (!map.has(key)) {
            map.set(key, { cnpj, idSupera, vlUnitRaw, count: 0 });
          }
          const entry = map.get(key);
          entry.count++;
        }

        const lines = [];
        for (const entry of map.values()) {
          // Formata campos
          // CNPJ: 14 chars, zeros a esquerda se faltar
          const fCnpj = entry.cnpj.padStart(14, '0');
          // ID Supera: 5 chars, zeros a esquerda
          const fId = entry.idSupera.padStart(5, '0');
          // Valor: 14 chars, zeros a esquerda (valor em centavos)
          const fVal = entry.vlUnitRaw.padStart(14, '0');
          // Qtde: 10 chars, zeros a esquerda
          const fQtde = String(entry.count).padStart(10, '0');
          
          lines.push(`${fCnpj};${fId};${fVal};${fQtde}`);
        }

        if (!lines.length) {
           toast.error('Nenhum dado gerado para exportação Supera');
           return;
        }

        const content = lines.join('\n');
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        const dataAtual = new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');
        a.download = `Consolidacao_Supera_${dataAtual}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        toast.success('Arquivo TXT gerado com sucesso!');
        setShowExportDropdown(false);
        return; // Retorna para nao executar o codigo padrao do Excel
      }

      if (!dados.length) {
        toast.error('Nenhum registro para exportar');
        return;
      }

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(dados);
      ws['!cols'] = [
        { wch: 24 }, { wch: 14 }, { wch: 12 }, { wch: 24 }, { wch: 8 }, { wch: 24 }, { wch: 14 }, { wch: 10 }, { wch: 40 }
      ];
      XLSX.utils.book_append_sheet(wb, ws, tipo);
      const dataAtual = new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');
      const nomeArquivo = `Consolidacao_${tipo}_${dataAtual}.xlsx`;
      XLSX.writeFile(wb, nomeArquivo);
      toast.success(`Arquivo ${nomeArquivo} gerado com sucesso!`);
      setShowExportDropdown(false);
    } catch (err) {
      console.error('Erro ao exportar XLS:', err);
      toast.error('Erro ao gerar arquivo XLS');
    }
  };

  const formatDateInput = (raw) => {
    const digits = String(raw || '').replace(/\D/g, '').slice(0,8);
    const dd = digits.slice(0,2);
    const mm = digits.slice(2,4);
    const yyyy = digits.slice(4,8);
    let out = '';
    if (dd) out += dd;
    if (mm) out += '/' + mm;
    if (yyyy) out += '/' + yyyy;
    return out;
  };

  const formatDateToISO = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split('/');
    if (parts.length !== 3) return null;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };

  const openModal = (item = null) => {
    setEditingItem(item);
    setFormData({
      id_mov: item?.id_mov || '',
      nome_cons: item?.nome_cons || '',
      nome_mov: item?.nome_mov || '',
      dt_nasc_mov: item?.dt_nasc_mov ? formatDateDisplay(item.dt_nasc_mov) : '',
      cpf_mov: item?.cpf_mov || '',
      id_faixa_mov: item?.id_faixa_mov || '',
      id_sub_mov: item?.id_sub_mov || '',
      id_grupo_mov: item?.id_grupo_mov || '',
      cd_empresa_mov: item?.cd_empresa_mov || '',
      empresa_mov: item?.empresa_mov || '',
      matricula_mov: item?.matricula_mov || '',
      dt_cad: item?.dt_cad ? formatDateDisplay(item.dt_cad) : '',
      mesano: item?.mesano || '',
      obs: item?.obs || ''
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingItem(null);
    setFormData({
      id_mov: '',
      nome_cons: '',
      nome_mov: '',
      dt_nasc_mov: '',
      cpf_mov: '',
      id_faixa_mov: '',
      id_sub_mov: '',
      id_grupo_mov: '',
      cd_empresa_mov: '',
      empresa_mov: '',
      matricula_mov: '',
      dt_cad: '',
      mesano: '',
      obs: ''
    });
  };

  const forceCloseModal = () => {
    setIsSaving(false);
    closeModal();
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!String(formData.nome_cons).trim()) {
      toast.error('Nome da consolidação é obrigatório');
      return;
    }
    setIsSaving(true);
    try {
      const payload = { 
        ...formData, 
        cpf_mov: formData.cpf_mov.replace(/\D/g, ''),
        dt_nasc_mov: formatDateToISO(formData.dt_nasc_mov), 
        dt_cad: formatDateToISO(formData.dt_cad) 
      };
      if (editingItem) {
        await api.put(`/consolidacao/${editingItem.id_cons}`, payload);
        toast.success('Consolidação atualizada com sucesso!');
      } else {
        await api.post('/consolidacao', payload);
        toast.success('Consolidação criada com sucesso!');
      }
      closeModal();
      loadItems();
    } catch (error) {
      const msg = error?.response?.data?.message || 'Erro ao salvar consolidação';
      toast.error(msg);
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (item) => {
    setDeletingItem(item);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!deletingItem) return;
    setIsDeleting(true);
    try {
      await api.delete(`/consolidacao/${deletingItem.id_cons}`);
      toast.success('Consolidação deletada com sucesso');
      setShowDeleteModal(false);
      setDeletingItem(null);
      loadItems();
    } catch (error) {
      toast.error('Erro ao deletar');
    } finally {
      setIsDeleting(false);
    }
  };

  const handleValidate = async () => {
    if (!filtered.length) {
      toast.error('Nenhum item para validar');
      return;
    }

    const updates = filtered.map(item => ({
      id_cons: item.id_cons,
      idade_mov: calcAge(item.dt_nasc_mov),
      valor_mov: getFaixaValor(item).replace('R$', '').trim(),
      unit_mov: getVlUnit(item).replace('R$', '').trim()
    }));

    try {
      const toastId = toast.loading('Validando registros...');
      await api.post('/consolidacao/validate', { updates });
      toast.dismiss(toastId);
      toast.success('Validação concluída com sucesso!');
      loadItems();
    } catch (error) {
      console.error(error);
      toast.dismiss();
      toast.error('Erro ao validar registros');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-[2000px] mx-auto">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Consolidação</h1>
        <p className="text-gray-600">Gerencie as consolidações</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center">
            <Archive className="h-8 w-8 text-blue-500" />
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Total</p>
              <p className="text-2xl font-bold text-gray-900">{items.length}</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center">
            <Search className="h-8 w-8 text-green-500" />
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Filtradas</p>
              <p className="text-2xl font-bold text-gray-900">{filtered.length}</p>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center">
            <Plus className="h-8 w-8 text-purple-500" />
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">Ações</p>
              <IconButton icon={Plus} onClick={() => openModal()} variant="primary" title="Nova Consolidação" />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow mb-6">
        <div className="border-b border-gray-200 px-6 py-4 flex justify-between items-center">
            <h3 className="text-lg font-medium text-gray-900 flex items-center gap-2">
                <Filter className="h-5 w-5" />
                Filtros e Agrupamento
            </h3>
            <IconButton
                icon={showFilters ? ChevronUp : ChevronDown}
                onClick={() => setShowFilters(!showFilters)}
                variant="secondary"
                size="sm"
                title={showFilters ? "Ocultar filtros" : "Exibir filtros"}
            />
        </div>
        
        {showFilters && (
        <div className="p-6">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <div className="relative flex items-center gap-2">
                <label className="text-xs font-bold text-gray-700 whitespace-nowrap">Filtro Mês/Ano:</label>
                <MesAnoFilterInput 
                    initialValue={mesAnoFilter} 
                    onApply={setMesAnoFilter} 
                />
                <div className="relative group">
                  <Info className="h-5 w-5 text-blue-500 cursor-help" />
                  <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 w-64 p-2 bg-blue-600 text-white text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50 text-center">
                    Campo Obrigatório para filtro (Faturamento do mês)
                    <div className="absolute left-1/2 -translate-x-1/2 top-full w-0 h-0 border-l-4 border-l-transparent border-r-4 border-r-transparent border-t-4 border-t-blue-600"></div>
                  </div>
                </div>
              </div>

              <div className="mt-2 flex items-center gap-2">
                <label className="text-xs font-bold text-gray-700 whitespace-nowrap">Filtro CDL/ACE:</label>
                <select
                  className="w-full sm:w-48 px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 text-sm"
                  value={cdlAceFilter}
                  onChange={(e) => setCdlAceFilter(e.target.value)}
                >
                  <option value="TODOS">TODOS</option>
                  <option value="ACE">ACE</option>
                  <option value="CDL">CDL</option>
                </select>
              </div>

              <div className="mt-4">
                <GroupPanel 
                  availableColumns={availableColumns}
                  activeGroups={breakFields}
                  onAddGroup={handleAddGroup}
                  onRemoveGroup={handleRemoveGroup}
                  onReorderGroup={handleReorderGroup}
                  onClearGroups={handleClearGroups}
                />
              </div>

              <SearchInput 
                initialValue={searchTerm} 
                onSearch={setSearchTerm} 
              />
              
              <p className="text-xs text-gray-500 mt-1 ml-1 mb-4">
                Filtros Inteligentes: <b>N:</b>Nome, <b>C:</b>CPF, <b>E:</b>Empresa. (Ex: <i>N:Lucas C:044</i>)
              </p>
            </div>
            <div className="flex items-center gap-2">
              <IconButton
                icon={Upload}
                onClick={() => setShowImportModal(true)}
                variant="success"
                title="Importar"
              />
              <IconButton
                icon={CheckCircle}
                onClick={handleValidate}
                variant="success"
                title="Validar"
              />
              <div className="relative">
                <button
                  onClick={() => setShowExportDropdown(v => !v)}
                  title="Exportar"
                  className="bg-green-600 hover:bg-green-700 text-white p-2 rounded-lg flex items-center justify-center gap-1 transition-colors"
                >
                  <FileSpreadsheet className="h-5 w-5" />
                  <ChevronDown className="h-4 w-4" />
                </button>
                {showExportDropdown && (
                  <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg z-10 border border-gray-200">
                    <div className="py-1">
                      <button
                        onClick={() => exportXLS('Supera')}
                        className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors gap-2"
                      >
                        <Landmark className="h-4 w-4 text-green-600" />
                        Supera
                      </button>
                      <button
                        onClick={() => exportXLS('Seguradora')}
                        className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors gap-2"
                      >
                        <Shield className="h-4 w-4 text-blue-600" />
                        Excel (Seguradora)
                      </button>
                      <button
                        onClick={exportPDF}
                        className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors gap-2"
                      >
                        <FileText className="h-4 w-4 text-red-600" />
                        Relatório Consolidado {cdlAceFilter !== 'TODOS' ? cdlAceFilter : ''}
                      </button>
                    </div>
                  </div>
                )}
              </div>
              <IconButton icon={Plus} onClick={() => openModal()} variant="primary" title="Nova Consolidação" />
            </div>
          </div>
        </div>
        )}
      </div>

      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200 table-auto">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">ID</th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                  <ColumnHeaderFilter
                    column="nome"
                    title="Nome"
                    options={getUniqueValues('nome')}
                    selectedValues={columnFilters.nome}
                    onFilterChange={(vals) => handleFilterChange('nome', vals)}
                  />
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                  <ColumnHeaderFilter
                    column="cpf"
                    title="CPF"
                    options={getUniqueValues('cpf')}
                    selectedValues={columnFilters.cpf}
                    onFilterChange={(vals) => handleFilterChange('cpf', vals)}
                  />
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">NASC.</th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">Idade</th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                  <ColumnHeaderFilter
                    column="empresa"
                    title="Empresa"
                    options={getUniqueValues('empresa')}
                    selectedValues={columnFilters.empresa}
                    onFilterChange={(vals) => handleFilterChange('empresa', vals)}
                  />
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                   <ColumnHeaderFilter
                    column="sub"
                    title="Sub"
                    options={getUniqueValues('sub')}
                    selectedValues={columnFilters.sub}
                    onFilterChange={(vals) => handleFilterChange('sub', vals)}
                  />
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                   <ColumnHeaderFilter
                    column="faixa"
                    title="Faixa"
                    options={getUniqueValues('faixa')}
                    selectedValues={columnFilters.faixa}
                    onFilterChange={(vals) => handleFilterChange('faixa', vals)}
                  />
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                  <ColumnHeaderFilter
                    column="grupo"
                    title="Grupo"
                    options={getUniqueValues('grupo')}
                    selectedValues={columnFilters.grupo}
                    onFilterChange={(vals) => handleFilterChange('grupo', vals)}
                  />
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                  <ColumnHeaderFilter
                    column="cdl_ace"
                    title="CDL/ACE"
                    options={getUniqueValues('cdl_ace')}
                    selectedValues={columnFilters.cdl_ace}
                    onFilterChange={(vals) => handleFilterChange('cdl_ace', vals)}
                  />
                </th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">Valor</th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">VL UNIT</th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">Matrícula</th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">Data</th>
                <th className="px-3 py-2 text-left text-[10px] font-medium text-gray-500 uppercase tracking-wider">
                  <ColumnHeaderFilter
                    column="mesano"
                    title="Mês/Ano"
                    options={getUniqueValues('mesano')}
                    selectedValues={columnFilters.mesano}
                    onFilterChange={(vals) => handleFilterChange('mesano', vals)}
                  />
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {(!breakFields.length ? currentItems : []).map((item) => (
                <tr key={item.id_cons} className="hover:bg-gray-50">
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.id_mov ?? '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.nome_mov || '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.cpf_mov || '-'}</td>
                                        <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{formatDateDisplay(item.dt_nasc_mov) || '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{calcAge(item.dt_nasc_mov)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getEmpresaNome(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.id_sub_mov ?? '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getFaixaDesc(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getGrupoDesc(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getCdlAce(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getFaixaValor(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{getVlUnit(item)}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.matricula_mov || '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{formatDateDisplay(item.dt_cad) || '-'}</td>
                  <td className="px-3 py-2 text-[10px] text-gray-900 whitespace-nowrap">{item.mesano || '-'}</td>
                </tr>
              ))}
              {breakFields.length > 0 && <RenderRows nodes={groupedData} />}
            </tbody>
          </table>
        </div>
        {filtered.length === 0 && (
          <div className="text-center py-12">
            <Archive className="mx-auto h-12 w-12 text-gray-400" />
            <h3 className="mt-2 text-sm font-medium text-gray-900">Nenhuma consolidação encontrada</h3>
            <p className="mt-1 text-sm text-gray-500">{mesAnoFilter ? 'Tente ajustar sua busca.' : 'Comece criando uma nova consolidação.'}</p>
          </div>
        )}

        {filtered.length > itemsPerPage && (
          <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between bg-gray-50">
            <div className="text-sm text-gray-700">
              Mostrando <span className="font-medium">{indexOfFirstItem + 1}</span> a <span className="font-medium">{Math.min(indexOfLastItem, filtered.length)}</span> de <span className="font-medium">{filtered.length}</span> resultados
            </div>
            <div className="flex items-center space-x-2">
              <IconButton
                icon={ChevronLeft}
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                variant="secondary"
                size="sm"
                title="Página anterior"
              />
              <span className="text-sm text-gray-700">
                Página {currentPage} de {totalPages}
              </span>
              <IconButton
                icon={ChevronRight}
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                variant="secondary"
                size="sm"
                title="Próxima página"
              />
            </div>
          </div>
        )}
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-20 mx-auto p-6 border w-full max-w-2xl shadow-lg rounded-lg bg-white">
            <div className="mt-3">
              <h3 className="text-lg font-medium text-gray-900 mb-4">{editingItem ? 'Editar Consolidação' : 'Nova Consolidação'}</h3>
              <form onSubmit={handleSave} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nome da Consolidação *</label>
                  <input type="text" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={formData.nome_cons} onChange={(e) => setFormData({ ...formData, nome_cons: e.target.value })} />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nome</label>
                  <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={formData.nome_mov} onChange={(e) => setFormData({ ...formData, nome_mov: e.target.value })} />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Data de Nascimento</label>
                    <div className="relative">
                      <input
                        ref={dtNascRef}
                        type="text"
                        placeholder="DD/MM/AAAA"
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        value={formData.dt_nasc_mov}
                        onChange={(e) => setFormData({ ...formData, dt_nasc_mov: formatDateInput(e.target.value) })}
                        onFocus={() => dtNascRef.current?.select?.()}
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">CPF</label>
                    <InputMask
                      mask="999.999.999-99"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={formData.cpf_mov}
                      onChange={(e) => setFormData({ ...formData, cpf_mov: e.target.value })}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <SearchableSelect
                      label="Empresa"
                      options={clientes.map(c => ({
                        value: c.id_cli,
                        label: c.nome_cli,
                        original: c
                      }))}
                      value={(() => {
                        const cli = clientes.find(c => c && String(c.cd_supera_cli) === String(formData.cd_empresa_mov))
                                 || clientes.find(c => c && String(c.nome_cli) === String(formData.empresa_mov));
                        return cli?.id_cli || '';
                      })()}
                      onChange={(val) => {
                        const selected = clientes.find(c => c.id_cli === val);
                        setFormData(prev => ({
                          ...prev,
                          empresa_mov: selected ? selected.nome_cli : '',
                          cd_empresa_mov: selected ? selected.cd_supera_cli : ''
                        }));
                      }}
                      placeholder="Selecione a empresa"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Cód. Empresa</label>
                    <input 
                      type="text" 
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 bg-gray-100" 
                      value={formData.cd_empresa_mov} 
                      readOnly 
                    />
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">ID Faixa</label>
                    <select
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={formData.id_faixa_mov}
                      onChange={(e) => setFormData({ ...formData, id_faixa_mov: e.target.value })}
                    >
                      <option value="">Selecione a faixa</option>
                      {faixas.map((f) => (
                        <option key={f.id} value={f.id}>{f.desc_faixa}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Sub</label>
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={formData.id_sub_mov}
                      onChange={(e) => {
                        const v = e.target.value.replace(/[^0-9]/g, '');
                        setFormData({ ...formData, id_sub_mov: v });
                      }}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">ID Grupo</label>
                    <select
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={formData.id_grupo_mov}
                      onChange={(e) => setFormData({ ...formData, id_grupo_mov: e.target.value })}
                    >
                      <option value="">Selecione o grupo</option>
                      {grupos.map((g) => (
                        <option key={g.id_grupo} value={g.id_grupo}>{g.desc_grupo}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Matrícula</label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={formData.matricula_mov} onChange={(e) => setFormData({ ...formData, matricula_mov: e.target.value })} />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Data Cadastro</label>
                    <input
                      type="text"
                      placeholder="DD/MM/AAAA"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={formData.dt_cad}
                      onChange={(e) => setFormData({ ...formData, dt_cad: formatDateInput(e.target.value) })}
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Mês/Ano</label>
                    <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={formData.mesano} onChange={(e) => setFormData({ ...formData, mesano: e.target.value })} />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Observações</label>
                  <textarea
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    rows="3"
                    value={formData.obs}
                    onChange={(e) => setFormData({ ...formData, obs: e.target.value })}
                  />
                </div>

                <div className="flex justify-end space-x-3 pt-4">
                  <IconButton icon={X} onClick={closeModal} variant="secondary" title="Cancelar" />
                  <IconButton icon={X} onClick={forceCloseModal} variant="secondary" title="Fechar" />
                  <IconButton icon={Save} type="submit" disabled={isSaving} variant="primary" title={isSaving ? 'Salvando...' : (editingItem ? 'Atualizar' : 'Criar')} />
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {obsModalItem && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" onClick={() => setObsModalItem(null)}>
          <div className="relative top-20 mx-auto p-5 border w-full max-w-lg shadow-lg rounded-md bg-white" onClick={(e) => e.stopPropagation()}>
            <div className="mt-3">
              <h3 className="text-lg font-medium text-gray-900 mb-2">Observação da Consolidação #{obsModalItem.id_cons}</h3>
              <div className="p-3 border border-gray-200 rounded bg-gray-50 whitespace-pre-wrap text-sm text-gray-800">
                {obsModalItem.obs && String(obsModalItem.obs).trim() ? obsModalItem.obs : 'Sem observação.'}
              </div>
              <div className="mt-4 flex justify-end">
                <IconButton icon={X} onClick={() => setObsModalItem(null)} variant="secondary" title="Fechar" />
              </div>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-24 mx-auto p-5 border w-full max-w-lg shadow-lg rounded-md bg-white">
            <div className="mt-3">
              <h3 className="text-lg font-medium text-gray-900 mb-2">Excluir Consolidação</h3>
              <p className="text-sm text-gray-700">Tem certeza que deseja excluir esta consolidação?</p>
              <div className="mt-4 flex justify-end gap-2">
                <IconButton icon={X} onClick={() => { setShowDeleteModal(false); setDeletingItem(null); }} variant="secondary" title="Cancelar" />
                <IconButton icon={Trash2} onClick={confirmDelete} disabled={isDeleting} variant="danger" title={isDeleting ? 'Excluindo...' : 'Excluir'} />
              </div>
            </div>
          </div>
        </div>
      )}

      <ImportModal
        isOpen={showImportModal}
        onClose={() => setShowImportModal(false)}
        onImport={handleImportData}
        fields={importFields}
      />
    </div>
  );
};

export default Consolidacao;
